exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/application.vue
 ** module id = 61
 ** module chunks = 0
 **/